import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Instagram, Facebook, Mail } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-[#2b1b1c] text-[#fcfbf8] mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo variant="light" size={72} />
          <p className="mt-6 max-w-md font-italic-serif text-lg leading-relaxed text-[#e0c07a]">
            Timeless drapes, woven with heritage. Sarees by Raunak curates hand-crafted six-yard treasures from the looms of India.
          </p>
          <div className="flex items-center gap-4 mt-6">
            <a href="https://www.instagram.com/sareesbyraunak/" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a34a]" data-testid="social-instagram" aria-label="Instagram @sareesbyraunak"><Instagram size={18} /></a>
            <a href="#" className="hover:text-[#c9a34a]" data-testid="social-facebook"><Facebook size={18} /></a>
            <a href="mailto:hello@sareesbyraunak.com" className="hover:text-[#c9a34a]" data-testid="social-email"><Mail size={18} /></a>
          </div>
        </div>
        <div>
          <h4 className="text-sm tracking-[0.2em] uppercase mb-4 text-[#c9a34a]">Shop</h4>
          <ul className="space-y-2 text-sm text-[#e8e4db]">
            <li><Link to="/shop?category=Banarasi">Banarasi</Link></li>
            <li><Link to="/shop?category=Kanjivaram">Kanjivaram</Link></li>
            <li><Link to="/shop?category=Silk">Silk</Link></li>
            <li><Link to="/shop?category=Chiffon">Chiffon</Link></li>
            <li><Link to="/shop?category=Cotton">Cotton</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm tracking-[0.2em] uppercase mb-4 text-[#c9a34a]">Atelier</h4>
          <ul className="space-y-2 text-sm text-[#e8e4db]">
            <li><Link to="/about" data-testid="footer-about">Our Story</Link></li>
            <li><Link to="/care" data-testid="footer-care">Care Guide</Link></li>
            <li><Link to="/shop">Shipping & Returns</Link></li>
            <li><Link to="/contact" data-testid="footer-contact">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#7a1e2b]/40">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row justify-between items-center text-xs text-[#c9a34a] tracking-widest uppercase gap-2">
          <span>© {new Date().getFullYear()} Sarees by Raunak</span>
          <span>Grace in every drape</span>
        </div>
      </div>
    </footer>
  );
}
